<template>
	<router-link :to="{ name: 'home' }" class="inline-block" :aria-label="`${siteName} home`">
        <img
            :class="className"
            :src="logoSrc"
            :alt="`${siteName} logo`"
            :width="width"
            :height="height"
            decoding="async"
            loading="lazy"
        />
    </router-link>
</template>

<script>
import { mapActions, mapState } from 'pinia'
import { useAppStore } from '../../store/app'
import { useActionStore } from '../../store/action'

export default {
	props: {
		className: {
			type: String,
			//default: 'max-h-10'
		},
        width: {
            type: Number,
            default: 160
        },
        height: {
            type: Number,
            default: 32
        }
	},
    data(){
        return {
            siteLogo : window.siteConfig.siteLogo,
            siteLogoDarkMode : window.siteConfig.siteLogoDarkMode,
            siteName: window.siteConfig.siteName
        }
    },
    computed: {
		...mapState(useAppStore, ['darkmode', 'systemMode']),
        logoSrc(){
            if (this.darkmode === 'on' || (this.darkmode === 'auto' && this.systemMode === 'dark')) {
                return this.siteLogoDarkMode;
            }
            return this.siteLogo;
        }
	},
    methods: {
        ...mapActions(useActionStore, ['doSamePage']),
        goToHome(){}
    }
}
</script>
